import { FC } from 'react';
import { UserProfile } from '@clerk/clerk-react';

import classes from './style.module.css';

// Match the Profile/Security tabs to the sidebar nav's hover and active states
// (see SectionListNavLink/style.module.css).
//
// Clerk scales its radii off variables.borderRadius (sm = 0.66x, lg = 1.33x,
// xl = 2x), so the elements below that use the sm/lg/xl sizes are pinned to
// --radius-sm too. Avatars and other circles are left round.
const radiusSm = { borderRadius: 'var(--radius-sm)' };

const userProfileAppearance = {
  variables: {
    borderRadius: 'var(--radius-sm)',
  },
  elements: {
    // Same border and shadow as the app's Dialog (.popup)
    cardBox: {
      ...radiusSm,
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'var(--color-border-medium)',
      boxShadow: 'var(--shadow-lg)',
    },
    card: radiusSm,
    navbar: radiusSm,
    // Clerk draws the content panel as its own card (a 1px ring plus a shadow)
    // flush against cardBox's edges, which doubles up the outer border. Keep
    // only a divider next to the tabs.
    scrollBox: {
      ...radiusSm,
      boxShadow: 'none',
      borderLeft: '1px solid var(--color-border-light)',
    },
    profileSectionItem: radiusSm,
    actionCard: radiusSm,
    popoverBox: radiusSm,
    selectOptionsContainer: radiusSm,
    menuItem: radiusSm,
    tagPillContainer: radiusSm,
    badge: radiusSm,
    navbarButton: {
      borderRadius: 0,
      color: 'var(--color-brand-charcoal)',
      '&:hover': {
        backgroundColor: 'var(--color-brand-cream-200)',
      },
    },
    navbarButton__active: {
      backgroundColor: 'var(--color-brand-cream-500)',
      fontWeight: 600,
      '&:hover': {
        backgroundColor: 'var(--color-brand-cream-500)',
      },
    },
  },
};

type UserProfileModalProps = {
  setUserProfileOpen: (open: boolean) => void;
};

export const UserProfileModal: FC<UserProfileModalProps> = ({
  setUserProfileOpen,
}) => {
  return (
    <div
      className={classes.background}
      onClick={(e) => {
        // If the user clicks outside the dialog, close it
        if (e.target === e.currentTarget) setUserProfileOpen(false);
      }}
      role="presentation"
    >
      <div className={classes.backgroundProfile}>
        <UserProfile routing="hash" appearance={userProfileAppearance} />
      </div>
    </div>
  );
};
